import { irm_actionNotAllowedOnThisConversation } from 'owa-locstrings/lib/strings/irm_actionnotallowedonthisconversation.locstring.json';
import { itemHeaderForward } from 'owa-locstrings/lib/strings/itemheaderforward.locstring.json';
import loc, { format } from 'owa-localize';
import confirmItemActionAllowed from '../utils/confirmItemActionAllowed';
import getLatestNonDraftItemIdFromConversation from '../utils/getLatestNonDraftItemIdFromConversation';
import { ClientItemId } from 'owa-client-ids';
import { lazyForwardMessage } from 'owa-mail-compose-actions';
import * as mailModuleOrchestrator from 'owa-mail-module-orchestrator';
import { InstrumentationContext } from 'owa-mail-store';
import IRMRestrictions from 'owa-mail-store/lib/store/schema/IRMRestrictions';
import allowResponseForSmimeConversation from 'owa-smime/lib/utils/allowResponseForSmimeConversation';

import { action } from 'satcheljs/lib/legacy';
import { ActionSource } from 'owa-analytics-actions';

export default action('forwardConversation')(async function forwardConversation(
    conversationId: ClientItemId,
    actionSource: ActionSource,
    instrumentationContexts: InstrumentationContext[],
    suppressServerMarkReadOnReplyOrForward: boolean
) {
    const referenceItemId = await getLatestNonDraftItemIdFromConversation(conversationId);
    if (referenceItemId && referenceItemId.Id) {
        const restrictionToConfirm = <IRMRestrictions>{ ForwardAllowed: true };
        if (
            confirmItemActionAllowed(
                referenceItemId.Id,
                restrictionToConfirm,
                format(loc(irm_actionNotAllowedOnThisConversation), loc(itemHeaderForward))
            ) &&
            allowResponseForSmimeConversation(referenceItemId.Id, loc(itemHeaderForward))
        ) {
            lazyForwardMessage.importAndExecute(
                referenceItemId,
                actionSource,
                instrumentationContexts,
                suppressServerMarkReadOnReplyOrForward
            );
            mailModuleOrchestrator.lazyOnReplyOrReplyAllOrForwardMessage.importAndExecute();
        }
    }
});
